import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, AppConfig } from './config';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  url: string;
  constructor(private http: HttpClient, @Inject(APP_CONFIG) config: AppConfig) { 
    this.url = `${config.apiEndpoint}/notification`;
  }
  getNotifications(){
    return this.http.get(this.url);
  }
  updateNotification(id:number){
    return this.http.patch(`${this.url}/${id}`, {});
  }
}
